<template>
  <v-row>
    <!-- <p>{{ ItemRow }}</p> -->
    <v-col cols="12" sm="6" md="3">
      <v-text-field
        readonly
        filled
        success
        shaped
        dark
        :value="ItemRow.ItemName"
        label="Item Name"
      ></v-text-field>
    </v-col>
    <v-col cols="12" sm="6" md="2">
      <v-text-field
        dark
        filled
        success
        shaped
        readonly
        :prefix="ItemRow.UnitType || ''"
        :value="ItemRow.exp.toLocaleString()"
        :label="'Expected ' + ItemRow.UnitType"
      ></v-text-field>
    </v-col>
    <v-col cols="12" sm="6" md="2">
      <v-text-field
        dark
        outlined
        :prefix="ItemRow.UnitType || ''"
        :value="ItemRow.qty.toLocaleString()"
        @input="InputEventQty"
        :rules="[IsNum]"
        :label="ItemRow.UnitType + ' QTY'"
      ></v-text-field>
    </v-col>
    <v-col cols="12" sm="6" md="2">
      <v-text-field
        dark
        readonly
        filled
        success
        shaped
        :prefix="ItemRow.cash || ''"
        :value="ItemRow.unitPrice.toLocaleString()"
        :label="ItemRow.UnitType + ' price'"
      ></v-text-field>
    </v-col>
    <v-col cols="12" sm="6" md="3">
      <v-text-field
        dark
        readonly
        filled
        success
        shaped
        :prefix="ItemRow.cash || ''"
        :value="TotalPrice ? TotalPrice.toLocaleString() : TotalPrice"
        :label="'Total ' + ItemRow.UnitType + ' price'"
      ></v-text-field>
    </v-col>
  </v-row>
</template>
<script>
export default {
  props: {
    ItemRow: { type: Object, required: true },
  },
  computed: {
    TotalPrice() {
      return this.ItemRow.unitPrice * this.ItemRow.qty;
    },
  },
  watch: {
    // TotalPrice() {
    //   if (!this.ItemRow.exp) this.ItemRow.exp = this.ItemRow.qty;
    // }
  },
  methods: {
    IsNum(v) {
      return !isNaN(v.replace(/,/g, "")) || "it is number";
    },

    InputEventQty(v) {
      if (isNaN(v.replace(/,/g, ""))) return;
      this.ItemRow.qty = Number(v.replace(/,/g, ""));
    },
  },
};
</script>
